import React from 'react';
import FeedTab from 'views/groups/components/FeedTab';
import PlayersTab from 'views/groups/components/PlayersTab';
import GroupCalendar from 'views/groups/calendar/GroupCalendar';
import Leagues from 'views/groups/leagues';
import LeagueStats from 'views/groups/leagues/LeagueStats';
import LeagueMatches from 'views/groups/leagues/LeagueMatches';
import ResourceCalendar from 'views/groups/calendar';
import MembershipPricing from 'views/groups/membership/MembershipPricing';
import MainCard from 'ui-component/cards/MainCard';
import LeaderboardTable from 'views/leagues/LeagueHome/TournamentManager/LeagueLeaderboardTable';
import LadderGraph from 'views/leagues/LeagueHome/Leaderboard/LadderGraph';
import { Grid, Typography } from '@mui/material';
import Chip from 'ui-component/extended/Chip';
import {
    TAB_FEED,
    TAB_MEMBERS,
    TAB_EVENTS,
    TAB_LEADERBOARD,
    TAB_LADDER_GRAPH,
    TAB_LEAGUE_STATS,
    TAB_MATCHES,
    TAB_SCHEDULE,
    TAB_MEMBERSHIPS
} from 'views/groups/components/groupTabs';
import { gridSpacing } from 'store/constant';

const GroupTabPanel = ({ groupTab, groupId, groupInfo, isGroupRoute, hasLeaderboard, week, leaderboard, setGroupTab }) => {
    switch (groupTab) {
        case TAB_FEED:
            return <FeedTab groupId={groupId} setGroupTab={setGroupTab} />;
        case TAB_MEMBERS:
            return <PlayersTab />;
        case TAB_SCHEDULE:
            return isGroupRoute ? <GroupCalendar groupId={groupId} /> : <ResourceCalendar groupId={groupId} editable />;
        case TAB_EVENTS:
            return <Leagues groupId={groupId} clubId={groupInfo?.group?.club?.id} />;
        case TAB_LEADERBOARD:
            return (
                <MainCard
                    title={
                        <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
                            <Grid item>
                                <Grid container alignItems="center">
                                    <Typography variant="h3">{hasLeaderboard ? `Leaderboard - Week ${week}` : 'Roster'}</Typography>
                                    {!hasLeaderboard && (
                                        <Grid ml={1}>
                                            <Chip label="No Sessions Yet" />
                                        </Grid>
                                    )}
                                    <Typography variant="caption" ml={1} />
                                </Grid>
                            </Grid>
                        </Grid>
                    }
                    content={false}
                >
                    <LeaderboardTable
                        leagueId={groupInfo?.group?.league?.id}
                        hasLeaderboard={hasLeaderboard}
                        week={week}
                        leagueLeaderboard={leaderboard}
                    />
                </MainCard>
            );
        case TAB_LADDER_GRAPH:
            return <LadderGraph leagueId={groupInfo?.group?.league?.id} />;
        case TAB_LEAGUE_STATS:
            return <LeagueStats leagueId={groupInfo?.group?.league?.id} type={groupInfo?.group?.league?.event_type} />;
        case TAB_MATCHES:
            return (
                <LeagueMatches
                    leagueId={groupInfo?.group?.league?.id}
                    type={groupInfo?.group?.league?.event_type}
                    isAdmin={groupInfo?.user_group?.role === 'admin'}
                />
            );
        case TAB_MEMBERSHIPS:
            return <MembershipPricing clubId={groupInfo?.group?.club?.id} />;
        default:
            return <FeedTab groupId={groupId} />;
    }
};

export default GroupTabPanel;
